import { Cookies } from '@fff-web/fff-utilities';

const COOKIE_SESSION_NAME = 'sm_session_info';

const getUserSession = () => {
  const sessionInfoCookie = Cookies.getCookie(COOKIE_SESSION_NAME);
  const sessionInfo = sessionInfoCookie ? JSON.parse(sessionInfoCookie) : null;
  return {
    sessionId: (sessionInfo && sessionInfo.sessionId) || '',
    sessionCreationDate: (sessionInfo && sessionInfo.sessionCreationDate) || '',
  };
};

export { getUserSession };
